import { useTranslation } from 'react-i18next'

import {
  QA_NAME_SHOW_LESS_BUTTON,
  QA_NAME_SHOW_MORE_BUTTON,
} from '../../../../../../constants/qa'
import { useReadMore } from '../../../../../../hooks'
import { getQaSelector } from '../../../../../../utils/common'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import Text from '../../../../../Text'
import {
  APPLICANT_DECISION_NOTE_CLAMP_LINES,
  QA_NAME_APPLICANT_DECISION_NOTE,
} from '../ApplicantDecisionPanel.constants'

import * as styles from '../ApplicantDecisionPanel.module.css'

function ApplicantDecisionNote({ label, text }) {
  const { t } = useTranslation()

  const { handleClickReadMore, isReadMore, showReadMore, textRef } =
    useReadMore({
      maxLines: APPLICANT_DECISION_NOTE_CLAMP_LINES,
      textData: text,
    })

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_DECISION_NOTE })}
      className={styles.note}
    >
      <Text isSecondary className={styles.noteLabel}>
        {label}
      </Text>
      <Text className={styles.noteText} ref={textRef}>
        {text}
      </Text>
      {showReadMore ? (
        <Button.Contained
          isGrey
          className={styles.noteReadMore}
          height={BUTTON_HEIGHT_24}
          qaName={
            isReadMore ? QA_NAME_SHOW_LESS_BUTTON : QA_NAME_SHOW_MORE_BUTTON
          }
          text={t(
            isReadMore
              ? 'Notification.CommonReadLessBtnKey'
              : 'Notification.CommonReadMoreBtnKey'
          )}
          onClick={handleClickReadMore}
        />
      ) : null}
    </div>
  )
}

export default ApplicantDecisionNote
